function showItems(id) {
  const showMoreItem = document.querySelector(`.showMore--${id}`);
  const itemsInfo = document.querySelectorAll(`.dd-line--${id}`);
  if (showMoreItem != null) {
    if (showMoreItem.innerHTML.includes('Mostrar')) {
      showMoreItem.innerHTML = 'Esconder itens -';
    } else {
      showMoreItem.innerHTML = 'Mostrar itens +';
    }
  }
  if (itemsInfo != null && itemsInfo.length) {
    itemsInfo.forEach((element) => {
      element.classList.toggle('hidden');
    });
  }
}

async function expireCart() {
  const url = 'https://www.caffeinearmy.com.br/cart/clear.js';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
  }).then(response => {
    localStorage.removeItem('cartTimestamp');
    window.location.reload();
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function handleCartExpiration(cartExpiration) {
  const cartTimestamp = localStorage.getItem('cartTimestamp');
  const now = Date.now();

  if (cartTimestamp && now - cartTimestamp > Number(cartExpiration)) {
    expireCart();
  } else {
    localStorage.setItem('cartTimestamp', now.toString());
  }
}

async function handleCheckoutWithDiscount(discountCode) {
  let primeUrl = `https://app.caffeinearmy.com.br/assinatura/checkout-prime/`
  if (document.querySelector('.product-in-prime')) {
    let primeProductConfigList = []
    document.querySelectorAll('.product-in-prime').forEach((element) => {
      const productCheckoutInfo = element?.value?.split('--')
      primeProductConfigList.push({
        currentProduct: productCheckoutInfo[0],
        quantity: Number(productCheckoutInfo[1]),
        cycles: Number(productCheckoutInfo[2])
      })
    });
    document.querySelectorAll('.one-cicle-prime').forEach((element) => {
      const productCheckoutInfo = element?.value?.split('--')
      primeProductConfigList.push({
        currentProduct: productCheckoutInfo[0],
        quantity: Number(productCheckoutInfo[1]),
        cycles: Number(productCheckoutInfo[2])
      })
    });
    await createPrimeCheckout(primeProductConfigList)
  } else {
    Cookies.set('discount_code', discountCode);
    window.location.href = '/checkout';
  }
}

function formatCurrency(value) {
  const numberValue = parseFloat(value) / 100;

  // Verifica se o valor é um número válido
  if (isNaN(numberValue)) {
    return 'Valor inválido';
  }

  // Formata o número para a moeda brasileira (BRL)
  const formattedValue = numberValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });

  return formattedValue;
}

async function applyDiscountToCard(cartData) {
  const total = cartData?.data?.discountedPrice
  const subtotal = cartData?.data?.totalPriceSelected
  const percentage = cartData?.data?.discountPercentage

  let discount = subtotal - total;

  let itemCount = 0


  const response = await fetch('/cart.js');
  const cart = await response.json();
  if (cart && cart.items) {
    for (let i = 0; i < cart.items.length; i += 1) {
      if (!cart.items[i].product_title.includes('Brinde')) {
        itemCount += 1
      }
    }
  }

  const discountElement = `
    <div class="discount__tag__container">
      ${percentage}% OFF
    </div>
    `

    const discountElementUpsell = `
    <div class="discount__tag__upsell__container">
      ${percentage}% OFF
       </div>
    `

  const freeItemElement = `
    <div class="discount__tag__container">
      GRÁTIS!
    </div>
    `

  if (percentage && percentage > 0) {
    const upsellItemPromoText = document.querySelectorAll('.related_product_uptext')

    if (upsellItemPromoText.length > 0) {
      upsellItemPromoText.forEach((element) => {
        element.innerHTML = `<p>Leve junto com</p> ${discountElementUpsell}`;
      });
    }


    for (const product of cart.items) {
      const discountedPricePerItem = numberToCurrency(product.presentment_price - product.presentment_price * percentage / 100);
      const discountContainer = document.getElementById(`totalDiscount--${product.id}`);
      const fullPriceContainer = document.getElementById(`priceTotal--${product.id}`);
      if (discountContainer && fullPriceContainer && !product.product_title.includes('Brinde')) {
        fullPriceContainer.classList.add('cutted_price');
        discountContainer.innerHTML = discountedPricePerItem;
        discountContainer.classList.remove('hidden-important');
      }

      if (product.presentment_price > 0) {
        const cartDetailsElement = document.querySelector(`.discount-tag-box--${product.id}`);
        if(cartDetailsElement) cartDetailsElement.innerHTML = discountElement
      } else {
        const cartDetailsElement = document.querySelector(`.discount-tag-box--${product.id}`);
        if(cartDetailsElement) cartDetailsElement.innerHTML = freeItemElement
      }
    }
  }


  return;

  const discountPerItem = discount.toFixed(2) / itemCount
  if (discount > 0) {
    for (const product of cart.items) {
      const discountedPricePerItem = (product.presentment_price - (discountPerItem / (product.quantity))).toFixed(2);
      const discountContainer = document.getElementById(`totalDiscount--${product.id}`);
      const fullPriceContainer = document.getElementById(`priceTotal--${product.id}`);
      if (discountContainer && fullPriceContainer && !product.product_title.includes('Brinde')) {
        fullPriceContainer.classList.add('cutted_price');
        discountContainer.innerHTML = "R$ " + discountedPricePerItem;
        discountContainer.classList.remove('hidden-important');
      }
    }
  }
}
function countDiscountInProducts(cartData) {
  const total = cartData?.data?.discountedPrice
  const subtotal = cartData?.data?.totalPriceSelected

  let discount = subtotal - total;

  const discountContainer = document.querySelector('#discount__container');
  const discountValue = document.querySelector('.discount_value');

  if (discountContainer && discountValue) {
    if (discount > 0) {
      discountContainer.style.display = 'flex';
      discountValue.style.color = '#4f9931'
      discountValue.innerText = "-R$ " + String(discount.toFixed(2)).replace('.', ',')
    } else {
      discountContainer.style.display = 'none';
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.discountChange, function (event) {
    const totalPriceElements = document.querySelectorAll('#totalDiscount');
    const priceTotalElements = document.querySelectorAll('#priceTotal');
    const discountPercentage = event.data.discountPercentage;
    setTimeout(() => applyDiscountToCard(event), 1000)

    countDiscountInProducts(event);

    if (priceTotalElements.length > 0 && totalPriceElements.length > 0 && discountPercentage > 0) {
      priceTotalElements.forEach((priceTotalElement, index) => {
        priceTotalElement.style.textDecoration = 'line-through';
        priceTotalElement.style.color = '#495057';
        priceTotalElement.style.fontSize = '10px';
        const priceTotal = parseFloat(priceTotalElement.innerHTML.split('R$')[1].replace('.', '').replace(',', '.'));
        const subtotal = priceTotal - (priceTotal * discountPercentage / 100);

        if (totalPriceElements[index]) {
          totalPriceElements[index].innerHTML = formatCurrency(subtotal * 100);
          totalPriceElements[index].classList.remove('hidden-important');
        }
      });
    }
  });
});

function defineNumberOrNull(value) {
  return value > 0 ? value : null
}

window.addEventListener('DOMContentLoaded', () => {
  const productResume = document.querySelectorAll('dd');
  if (productResume != null) {
    productResume.forEach((element) => {
      if (element && element.innerHTML) {
        element.innerHTML = element.innerHTML.split(',').join('<br/>');
      }
    });
  }
});